const NumberNotationFormatter = Intl.NumberFormat('ja-JP', {
  style: 'decimal',
  notation: 'compact',
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
});

const CurrencyFormatter = Intl.NumberFormat('ja-JP', {
  style: 'currency',
  currency: 'JPY',
  currencyDisplay: 'narrowSymbol',
});

const CurrencyNotationFormatter = Intl.NumberFormat('ja-JP', {
  style: 'currency',
  currency: 'JPY',
  currencyDisplay: 'narrowSymbol',
  notation: 'compact',
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
});

export class CurrencyDomainService {
  static readonly currencyUnit: string = '¥';

  static notationFormat(num: number): string {
    return NumberNotationFormatter.format(num);
  }

  static priceFormat(num: number): string {
    return CurrencyFormatter.format(num);
  }

  static priceNotationFormat(num: number): string {
    return CurrencyNotationFormatter.format(num);
  }
}
